import errorJson from "../config/error.json";
export default {
  methods: {
    // DISPATCHES an error event to be handled by listeners (e.g., in EventsDefinitions.js)
    // err: the error object (should contain a 'response' property)
    // prevent: if true, prevents the default error handling in the listener
    // actionEv: optional callback event name to be dispatched after handling
    // isErrorManager: optional if true, that activates centralized error handling
    setError(err, prevent, actionEv, isErrorManager) {
      let errorConfig = {
        isErrorManager: isErrorManager,
      };

      // If centralized management is used, the error json and the reference to the i18n $t function for translations are set.
      if (isErrorManager) {
        errorConfig.config = this.$t;
        errorConfig.errorJson = errorJson;
      }

      // If error is missing or is a server error (status >= 500), use a default error object
      if (!isErrorManager && (!err || err.response.status >= 500)) {
        err = {
          response: {
            status: "500",
            statusText: "server_error",
          },
        };
      }
      // Dispatch a custom event with error details
      document.dispatchEvent(
        new CustomEvent("error-" + err.response.status, {
          detail: {
            // If prevent is true, the listener will skip default error handling
            preventDefault: prevent || false,
            // Optional callback event to be triggered by the listener
            callbackEvent: actionEv,
            // Error response data
            data: err.response || "No response",
            ...errorConfig,
          },
        }),
      );
    },
    showLoader() {
      document.dispatchEvent(new CustomEvent("show-spinner-overlay"));
    },
    hideLoader() {
      document.dispatchEvent(new CustomEvent("hide-spinner-overlay"));
    },
  },
};
